import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String }

  toggle(event) {
    if (event) event.preventDefault()
    const dropdown = document.getElementById(this.idValue)
    if (dropdown) {
      const dropdownController = this.application.getControllerForElementAndIdentifier(dropdown, 'dropdown')
      if (dropdownController) {
        dropdownController.toggle(event)
      }
    }
  }
}
